import React from 'react';
import { IIconProps, sizeMap } from './types';

export const StarCircled = ({ className, size = 'medium' }: IIconProps) => (
  <svg
    className={className}
    width={sizeMap[size].width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.74319 2.33781C10.719 0.554065 13.281 0.554065 14.2568 2.3378C14.8368 3.39799 16.0766 3.91152 17.2364 3.57199C19.1877 3.00073 20.9993 4.81228 20.428 6.7636C20.0885 7.9234 20.602 9.16317 21.6622 9.74319C23.4459 10.719 23.4459 13.281 21.6622 14.2568C20.602 14.8368 20.0885 16.0766 20.428 17.2364C20.9993 19.1877 19.1877 20.9993 17.2364 20.428C16.0766 20.0885 14.8368 20.602 14.2568 21.6622C13.281 23.4459 10.719 23.4459 9.74319 21.6622C9.16317 20.602 7.9234 20.0885 6.7636 20.428C4.81228 20.9993 3.00073 19.1877 3.57199 17.2364C3.91152 16.0766 3.39799 14.8368 2.3378 14.2568C0.554065 13.281 0.554065 10.719 2.3378 9.74319C3.39799 9.16318 3.91152 7.9234 3.57199 6.7636C3.00073 4.81228 4.81228 3.00073 6.7636 3.57199C7.9234 3.91152 9.16317 3.39799 9.74319 2.33781Z"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
    />
    <path
      d="M12 7.41667L13.25 10.7917H16.5833L13.6667 12.6667L14.9167 15.6667L12 13.7917L9.08333 15.6667L10.3333 12.6667L7.41667 10.7917H10.75L12 7.41667Z"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
    />
  </svg>
);
